import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgCollapse = (props, ref) => /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: /* @__PURE__ */ jsx("path", { d: "M18.59 16.59L20 15.17L16.83 12L20 8.83L18.59 7.42L14 12L18.59 16.59ZM5.41 7.41L4 8.83L7.17 12L4 15.17L5.41 16.59L10 12L5.41 7.41Z", fill: "currentColor" }) });
const ForwardRef = forwardRef(SvgCollapse);
export { ForwardRef as ReactComponent };
